import * as angular from "angular";

angular
  .module('bringoz.admin.commissions')
  .constant('ConsolidatedCommissions_PN', {
    database: 'consolidatedCommission',
    isBranchEntity: true
  });
